export enum ApprovalStatus {
    Pending,
    Approved,
    DeclinedPending,
    Declined,
    Submitted,
}